/**
 * Playable - base class for objects that can begin and end play.
 * Maintains a PlayState enum and guards transitions so derived classes know their lifecycle stage.
 */
import { ObjectTracker } from '../systems/ObjectTracker.js';
import { ensure } from '../utils/Utils.js';

export enum PlayState {
    NotStarted = 'notStarted',
    Playing = 'playing',
    Ended = 'ended',
}

export class Playable {
  protected playState: PlayState = PlayState.NotStarted;

  constructor() {
    ObjectTracker.track(this);
  }

  public getPlayState(): PlayState {
    return this.playState;
  }

  public beginPlay() {
    if (!ensure(this.playState === PlayState.NotStarted)) {
      return;
    }
    this.playState = PlayState.Playing;
    this.doBeginPlay();
  }

  public endPlay() {
    if (!ensure(this.playState === PlayState.Playing)) {
      return;
    }
    this.playState = PlayState.Ended;
    this.doEndPlay();
  }

  public isPlaying() {
    return this.playState === PlayState.Playing;
  }

  public isPlayEnded() {
    return this.playState === PlayState.Ended;
  }

  /**
   * Resets play state so {@link beginPlay} can run again after the instance is moved to a new world.
   * @internal Used during level transitions that preserve select actors across `openLevel`.
   */
  public resetPlayStateForWorldTransition(): void {
    this.playState = PlayState.NotStarted;
  }

  protected doBeginPlay() {
  }

  protected doEndPlay() {
  }
}